<div class="autowcont allpads m-top-ii">
    <div class="basicrow f-reg f-black roboto-r">
        <div class="basicrow f-big">
            Confirmación
        </div>
        <div class="dts-rcrg m-top-ii text-center">
            <div class="left-number">
                <div class="basicrow">
                    <span class="roboto-b">N&uacute;mero de T&eacute;lefono</span><br />
                    <span class="f-big roboto-b">{{this.subscriber}}</span>
                </div>
            </div>
            <div class="right-number">
                <div class="basicrow l-pline-i">
                    <span class="roboto-b">Balance en Prepago Disponible</span><br />
                    <span class="f-lsemi roboto-b f-red">{{this.prepaidBalance | currency}}</span>
                </div>
            </div>
        </div>
        <div class="basicrow m-top-i">
            <div class="logline full"></div>
        </div>
        <div>
            <div class="confirmation-chart">
                <div class="item-recharge-mount">
                    MONTO DE RECARGA
                </div>
                <div class="value-recharge-mount">
                    {{this.amount| currency}}
                </div>
                <div class="item-ivu">
                    IVU
                </div>
                <div class="value-ivu">
                    {{this.tax| currency}}
                </div>
                <div class="item-payment-quantity">
                    CANTIDAD A PAGAR
                </div>
                <div class="value-payment-quantity f-red">
                    {{this.totalPagar| currency}}
                </div>
            </div>
            <div class="basicrow m-top-i">
                <div class="logline full"></div>
            </div>
            <div class="basicrow m-top-i m-bott-ii">
                <a class="btns red def-i pull-right vcenter" (click)="this.continuePrepaidRecharge()">
                    <span class="tabcell">
                        Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                </a>
                <a class="btns gray def-i pull-left vcenter" (click)="this.cancelPrepaidRecharge()">
                    <span class="tabcell">
                        Cancelar
                    </span>
                </a>
            </div>
        </div>
    </div>
</div>